import { EditRulePattern } from "./EditRulePattern";

export class EditRuleSet {
  patterns: EditRulePattern[];
}
